// Helpers
import { getRequest, publicApiUrl } from 'api/v3';

export function getEngagementReport(id) {
  return getRequest(publicApiUrl(`engagement_reports/${id}`));
}
